import React, { useState } from 'react';
import { NavigationProps } from '../types/navigation';
import { Button } from '../components/ui/Button';
import { MapPin, Lock, Info } from 'lucide-react';
import { useStore } from '../lib/store';
export function EventsPage({
  onNavigate
}: NavigationProps) {
  const {
    events,
    addReservation,
    reservations,
    user
  } = useStore();
  const [showPointsInfo, setShowPointsInfo] = useState(false);
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-388">
      <div className="px-6 pt-12 pb-4 bg-white sticky top-0 z-10 shadow-sm flex justify-between items-center" data-id="element-389">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-390">Fishing Spots</h1>
        <button onClick={() => setShowPointsInfo(true)} className="text-blue-500 text-sm font-bold flex items-center bg-blue-50 px-3 py-1 rounded-full" data-id="element-391">
          <Info className="w-4 h-4 mr-1" data-id="element-392" />
          How to earn points
        </button>
      </div>

      <div className="p-4 space-y-4" data-id="element-393">
        {events.map(event => {
        const isReserved = reservations.some(r => r.eventId === event.id);
        const isLocked = (user?.points || 0) < event.requiredPoints;
        return <div key={event.id} className={`bg-white rounded-xl p-4 shadow-sm flex flex-col space-y-3 relative overflow-hidden ${isLocked ? 'opacity-75' : ''}`} data-id="element-394">
              {isLocked && <div className="absolute inset-0 bg-gray-100/50 backdrop-blur-[1px] z-10 flex items-center justify-center" data-id="element-395">
                  <div className="bg-white px-4 py-2 rounded-xl shadow-lg flex items-center space-x-2" data-id="element-396">
                    <Lock className="w-4 h-4 text-gray-400" data-id="element-397" />
                    <span className="text-sm font-bold text-gray-600" data-id="element-398">
                      Requires {event.requiredPoints} pts
                    </span>
                  </div>
                </div>}

              <div className="flex justify-between items-start" data-id="element-399">
                <div data-id="element-400">
                  <span className="text-xs font-bold text-blue-500 uppercase tracking-wide" data-id="element-401">
                    {event.theme}
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-402">
                    {event.title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-403">
                    {event.brand} • {event.date}
                  </p>
                </div>
                <div className="bg-gray-100 px-2 py-1 rounded text-xs font-bold text-gray-600" data-id="element-404">
                  {event.time}
                </div>
              </div>

              <div className="flex items-center text-sm text-gray-600 bg-gray-50 p-2 rounded-lg" data-id="element-405">
                <MapPin className="w-4 h-4 mr-2 text-gray-400" data-id="element-406" />
                <span className="truncate" data-id="element-407">{event.address}</span>
              </div>

              <div className="flex items-center justify-between pt-2" data-id="element-408">
                <span className="text-sm font-medium text-gray-500" data-id="element-409">
                  {event.boxesLeft} / {event.totalBoxes} spots
                </span>
                <Button size="sm" onClick={() => !isReserved && addReservation(event.id)} disabled={isReserved || isLocked} className={isReserved ? 'bg-green-100 text-green-700 hover:bg-green-200' : 'px-6'} data-id="element-410">
                  {isReserved ? 'Reserved' : 'Paxa'}
                </Button>
              </div>
            </div>;
      })}
      </div>

      {/* Points Info Modal */}
      {showPointsInfo && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 animate-in fade-in" data-id="element-411">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" data-id="element-412">
            <button onClick={() => setShowPointsInfo(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" data-id="element-413">
              ✕
            </button>

            <h2 className="text-xl font-bold mb-4" data-id="element-414">How to earn points</h2>
            <div className="space-y-4" data-id="element-415">
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-416">
                <span data-id="element-417">Invite a friend</span>
                <span className="font-bold text-blue-600" data-id="element-418">+40 pts</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-419">
                <span data-id="element-420">Leave a review</span>
                <span className="font-bold text-blue-600" data-id="element-421">+30 pts</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-422">
                <span data-id="element-423">Redeem a box</span>
                <span className="font-bold text-blue-600" data-id="element-424">+20 pts</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl" data-id="element-425">
                <span data-id="element-426">Reserve a spot</span>
                <span className="font-bold text-blue-600" data-id="element-427">+10 pts</span>
              </div>
            </div>
            <Button onClick={() => setShowPointsInfo(false)} className="w-full mt-6" data-id="element-428">
              Got it
            </Button>
          </div>
        </div>}
    </div>;
}